import selectorSelectors from '../../redux/selector/selectors'
import { ResourceTargetSelectorState } from './reducer'
import { BasicTarget } from './model'

export const resourceTargetSelectors = <S>(getAll: (state: S) => ResourceTargetSelectorState) => {
    return {
        ...selectorSelectors<BasicTarget, S>(getAll),
        getAll: (state: S) => getAll(state)
    }
}
